import React, { useContext } from "react";
import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import { Link } from "react-router-dom";
import Default from "./Default";
import { construirEnlace } from "../../../helper/funciones";

const EnlaceOpcional = ({
  data,
  cab,
  campokey,
  hijos,
  indiceData,
  id_elemento,
}) => {
  const { enviarAModal } = useContext(FuncionesContext);
  const enlace_id_a = data[cab.id_a + "_enlace_id_a"] ?? cab.enlace_id_a;

  const disabled = getAtributo("disabled", data, cab);

  if (!enlace_id_a || disabled === "s") {
    return (
      <Default
        key={cab.id_a}
        data={data}
        cab={cab}
        hijos={hijos}
        campokey={campokey}
        id_elemento={id_elemento}
      />
    );
  }

  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    return cab.nombre;
  })();

  const enlace = construirEnlace(data, cab);

  if (cab.target === "modal") {
    return (
      <div
        onClick={() =>
          enviarAModal(enlace_id_a, enlace.params, {
            min_width_modal: cab.min_width_modal,
          })
        }
        id={id_elemento}
        style={{ textAlign: cab.align ?? "left" }}
      >
        <div
          className={` ${cab.className ?? ""}`} // classname retirado Listado_Switch_Enlace >
        >
          {cab.imagen_url ? (
            <img
              style={{ cursor: "pointer" }}
              height={"40px"}
              src={cab.imagen_url}
              alt="imagen"
            />
          ) : (
            <>{data[campokey] ?? cab.boton_texto}</>
          )}
        </div>
      </div>
    );
  }

  if (cab.target === "_blank") {
    return (
      <div id={id_elemento}>
        <a
          target="_blank"
          href={process.env.PUBLIC_URL + enlace.enlace_completo}
          rel="noopener noreferrer"
          className={`${cab.className ?? ""}`}
          id={id_elemento + "_ancla"}
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            {cab.imagen_url ? (
              <img
                style={{ cursor: "pointer" }}
                height={"40px"}
                src={cab.imagen_url}
                alt="imagen"
              />
            ) : (
              <>{data[campokey] ?? cab.boton_texto}</>
            )}

            {hijos}
          </div>
        </a>
      </div>
    );
  }

  if (cab.target === "_self") {
    return (
      <div id={id_elemento}>
        <a
          href={
            process.env.PUBLIC_URL +enlace.enlace_completo
          }
          rel="noopener noreferrer"
          className={`${cab.className ?? ""}`}
          id={id_elemento + "_ancla"}
        >
          <div style={{ textAlign: "center" }}>
            {cab.imagen_url ? (
              <img
                style={{ cursor: "pointer" }}
                height={"40px"}
                src={cab.imagen_url}
                alt="imagen"
              />
            ) : (
              <>{data[campokey] ?? cab.boton_texto}</>
            )}

            {hijos}
          </div>
        </a>
      </div>
    );
  }

  return (
    <div id={id_elemento}>
      <div className={`vista_dato ${cab.className ?? ""}`}>
        <Link
          to={{
            pathname: enlace.enlace,
            search: enlace.parametros,
          }}
        >
          {data[campokey]}
        </Link>
      </div>
    </div>
  );
};
export default EnlaceOpcional;
